export { default as ClipboardDocumentCheckSolidIcon } from './ClipboardDocumentCheckSolidIcon';
